import { render } from "./BrandStoryPage.vue?vue&type=template&id=a7093fa2&scoped=true"
import script from "./BrandStoryPage.vue?vue&type=script&lang=js"
export * from "./BrandStoryPage.vue?vue&type=script&lang=js"

import "./BrandStoryPage.vue?vue&type=style&index=0&id=a7093fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7093fa2"]])

export default __exports__